import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from "rxjs";
import { Event } from '../../models/event';
import { EventService } from '../../services/event.service';
import { TypeEventService } from '../../services/type-event.service';
import * as esLocale from "date-fns";
import { ApplyStatusService } from '../../services/apply-status.service';

@Component({
  selector: 'app-event-massive-dialog',
  templateUrl: './event-massive-dialog.component.html',
  styleUrls: ['./event-massive-dialog.component.css']
})
export class EventMassiveDialogComponent implements OnInit {
  @Input() editEvent: any;
  @Input() jobId: any;
  @Input() create: boolean;
  msgLoading: boolean;
  eventId: string;
  typeEventList: any;
  event: any;
  errorMessage: string;
  publicating: boolean;
  es: any;
  date: Date;
  time: Date;
  applyStatusList: any;
  status: any;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public eventService: EventService,
    public typeEventService: TypeEventService,
    public dialogRef: MdDialogRef<EventMassiveDialogComponent>,
    private applyStatusService: ApplyStatusService
  ) { }

  ngOnInit() {
    this.es = {
    firstDayOfWeek: 1,
      dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      dateFns: esLocale
    };

    this.publicating = false;
    this.getTypeEventList ();
    this.getApplyStatus();
    if (this.create) {
      this.event = {
        id: undefined,
        dateandtime: new Date(),
        details: '',
        type: undefined,
        apply_status: undefined,
        jobid: this.jobId,
      };
    } else {
      this.event = {
        id: this.editEvent.id,
        dateandtime: this.editEvent.start,
        details: this.editEvent.details,
        type: this.editEvent.type,
        apply_status: this.editEvent.status,
        jobid: this.jobId,
      };
    }
    this.date = new Date (this.event.dateandtime);
    this.time = new Date (this.event.dateandtime);
  }

  getApplyStatus () {
    this.applyStatusList = [];
    this.applyStatusList.push ({id:100, name:'Postulados'});
    this.applyStatusList.push ({id:275, name:'Preseleccionados'});
    this.applyStatusList.push ({id:-1, name:'Rechazados'});
    this.applyStatusList.push ({id:300, name:'Seleccionados'});
    this.applyStatusService.getApplyStatusList(1, 1000, null, 0).subscribe(
      data => {
        console.log(data);
        data.applystatus.forEach(element => {
          this.applyStatusList.push(element);
        });
      }
    );
  }

  getTypeEventList () {
    this.typeEventList = [];
    this.typeEventService.getTypeEventList(1, 1000)
    .subscribe(
      data => {
        this.typeEventList = data.eventtype;
      },
      error => {
      }
    );
  }

  onEvent() {
    if (this.create) {
      this.onPostEvent ();
    } else {
      this.onPutEvent ();
    }
  }

  onPostEvent () {
    this.publicating = true;
    const month = this.date.getMonth() + 1;
    const a = this.date.getFullYear() + '-' + month + '-' + this.date.getDate() + ' ' + this.time.getHours() +
    ':' + this.time.getMinutes() + ':00:00';
    this.event.dateandtime = new Date (a);
    let status = [];
    status.push(this.event.apply_status);
    this.event.apply_status = status;
    this.eventService.postEvent(this.event)
    .subscribe(
      data => {
        this.dialogRef.close();
      },
      error => {
        this.errorMessage = <any>error
        this.publicating = false;
      }
    );
  }

  onPutEvent () {
    this.publicating = true;
    const month = this.date.getMonth() + 1;
    const a = this.date.getFullYear() + '-' + month + '-' + this.date.getDate() + ' ' + this.time.getHours() +
    ':' + this.time.getMinutes() + ':00:00';
    this.event.dateandtime = new Date (a);
    this.eventService.putEvent(this.event)
    .subscribe(
      data => {
        this.dialogRef.close();
      },
      error => {
        this.errorMessage = <any>error
        this.publicating = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/event-massive-dialog/event-massive-dialog.component.ts